

import React from 'react';

const SIGN_META = {
  aries: { symbol: '♈', label: 'Aries' },
  tauro: { symbol: '♉', label: 'Tauro' },
  taurus: { symbol: '♉', label: 'Tauro' },
  geminis: { symbol: '♊', label: 'Géminis' },
  géminis: { symbol: '♊', label: 'Géminis' },
  gemini: { symbol: '♊', label: 'Géminis' },
  cancer: { symbol: '♋', label: 'Cáncer' },
  cáncer: { symbol: '♋', label: 'Cáncer' },
  leo: { symbol: '♌', label: 'Leo' },
  virgo: { symbol: '♍', label: 'Virgo' },
  libra: { symbol: '♎', label: 'Libra' },
  escorpio: { symbol: '♏', label: 'Escorpio' },
  scorpio: { symbol: '♏', label: 'Escorpio' },
  sagitario: { symbol: '♐', label: 'Sagitario' },
  sagittarius: { symbol: '♐', label: 'Sagitario' },
  capricornio: { symbol: '♑', label: 'Capricornio' },
  capricorn: { symbol: '♑', label: 'Capricornio' },
  acuario: { symbol: '♒', label: 'Acuario' },
  aquarius: { symbol: '♒', label: 'Acuario' },
  piscis: { symbol: '♓', label: 'Piscis' },
  pisces: { symbol: '♓', label: 'Piscis' },
};

function normalizeSign(sign) {
  return String(sign || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export default function FeedSignBadge({ sign = '', className = '' }) {
  const key = normalizeSign(sign);
  const meta = SIGN_META[key];

  if (!meta && !sign) return null;

  return (
    <span
      className={`feed-sign-badge ${className}`.trim()}
      title={meta?.label || sign}
    >
      <span className="feed-sign-badge__symbol">{meta?.symbol || '✦'}</span>
      <span className="feed-sign-badge__label">{meta?.label || sign}</span>
    </span>
  );
}